import { Alert, Box } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { Template } from "@app/common/components/Template";
import routes from "@app/config/routes";
import { useGetAccountingNoteElectronicPdf } from "@app/services/accountingNotes/hooks";
import { useNavigate, useParams } from "react-router-dom";

const AccountingNoteCreditDetail = () => {
  const navigate = useNavigate();
  const { invNoteId = "" } = useParams();

  const noteId = Number(invNoteId);

  const { data: notePdfData } = useGetAccountingNoteElectronicPdf(noteId, Boolean(noteId));

  const pdfIframeValue = notePdfData?.results?.pdf_url ?? "";

  return (
    <Template
      title="Resumen nota crédito"
      goBackButton={() => {
        navigate(routes.getAccountingNotes);
      }}
    >
      {pdfIframeValue ? (
        <Box h="72vh" data-testid="accountingnotes-credit-pdf-container">
          <iframe
            title="Vista previa nota crédito"
            src={pdfIframeValue}
            style={{ width: "100%", height: "100%", border: "none" }}
            data-testid="accountingnotes-credit-pdf-iframe"
          />
        </Box>
      ) : (
        <Alert
          icon={<IconAlertTriangle size={18} />}
          color="yellow"
          variant="light"
          data-testid="accountingnotes-credit-pdf-alert"
        >
          No fue posible cargar el PDF electrónico de la nota crédito.
        </Alert>
      )}
    </Template>
  );
};

export default AccountingNoteCreditDetail;
